<div class="center">
  <div class="row">
    <div class="col-12 col-md-4 offset-md-4">
      <div class="container-logo">
        <div class="row text-center">
          <div class="col-12">
            <img src="./assets/img/CHUBB_Logo_White.png" height="27.25" alt="logo de chubb">
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            @if (!givenName) {
              <h1>Bienvenido</h1>
            }
            @if (givenName) {
              <h1>Bienvenido, {{givenName}} {{familyName}}!</h1>
            }
          </div>
        </div>
        @if (givenName === null) {
          <div class="row section">
            <div class="col-12">
              <div class="form-group">
                <button class="btn btn-danger btn-bigger" (click)="go()">
                  Ingresar
                </button>
              </div>
            </div>
          </div>
        }

        @if (givenName !== null) {
          <div class="row section">
            <div class="col-12">
              <div class="form-group">
                <button class="btn btn-danger btn-bigger" (click)="go()">
                  Ingresar
                </button> &nbsp;
                <button class="btn btn-danger btn-bigger" (click)="logout()">
                  Cerrar Sesión
                </button>
              </div>
            </div>
          </div>
        }
        @if (showInvalidUser && givenName !== null) {
          <div class="row section">
            <div class="col-12">
              <h2>El usuario {{ givenName }} {{ familyName }} no est&aacute; habilitado en esta plataforma.</h2>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
